// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FractalsBase } from './FractalsBase';
export class FRACTALS3 extends FractalsBase {
    constructor() {
        super();
        this.initializeFractals('Fractals3', 3);
    }
    NextBar() {
        super.NextBar();
        this.processFractal(3);
    }
}
